import { useQuery } from '@tanstack/react-query'

import type { BookingConfirmationSummary } from '../../types/booking-session.js'

import { apiClient } from '../../lib/client.js'
import { bookingSessionKeys } from './keys.js'

export interface UseBookingConfirmationSummaryOptions {
  /** Polling interval in ms while the query is active. Useful for the SSP
   *  pending-payment page where we wait for the webhook to settle. */
  refetchInterval?: number
}

export const useBookingConfirmationSummary = (
  sessionId: string | undefined,
  options: UseBookingConfirmationSummaryOptions = {}
) =>
  useQuery({
    enabled: !!sessionId,
    queryFn: async () => {
      const response = await apiClient.client.get<BookingConfirmationSummary>(
        `/booking-session/${sessionId}/summary`
      )
      return response.data
    },
    queryKey: sessionId ? bookingSessionKeys.summary(sessionId) : bookingSessionKeys.all,
    refetchInterval: options.refetchInterval,
    retry: false,
    staleTime: options.refetchInterval ? 0 : 5 * 60 * 1000,
  })
